import CPFNormalize from './CPFNormalize';
import DateNormalize from './DateNormalize';
import HourMinuteNormalize from './HourMinuteNormalize';
import CNPJNormalize from './CNPJNormalize';
import CEPNormalize from './CEPNormalize';
import NumberNormalize from './NumberNormalize';
import DDDNormalize from './DDDNormalize';
import PhoneNormalize from './PhoneNormalize';
import DecimalNormalize from './DecimalNormalize';
import MoneyNormalize from './MoneyNormalize';
import DocumentNormalize from './DocumentNormalize';
import BooleanNormalize from './BooleanNormalize';

export {
  CPFNormalize,
  DateNormalize,
  HourMinuteNormalize,
  CNPJNormalize,
  CEPNormalize,
  NumberNormalize,
  DDDNormalize,
  PhoneNormalize,
  DecimalNormalize,
  MoneyNormalize,
  DocumentNormalize,
  BooleanNormalize,
};



// WEBPACK FOOTER //
// ./src/components/normalize/index.js